<template>
	<div class="l-pages">
		<ul class="l-pages-ul">
			<li class="l-pages-li" @click="changePage(1,`first`)">首页</li>
			<!-- <li class="l-pages-li" v-if="curr !== 1" @click="changePage((curr-1),`prev`)">上一页</li> -->
			<li :class="[`l-pages-li`,curr == s ? `l-pages-li-active`: ``,(s === `…`) ? `l-pages-li-not` : ``]" v-for="(s,i) in pageNum" :key="i" @click="(s !== `…`) && changePage(s)">
				<span>{{s}}</span>
			</li>
			<!-- <li class="l-pages-li" v-if="curr !== lifor" @click="changePage((curr+1),`next`)">下一页</li> -->
			<li class="l-pages-li" @click="changePage(pageNum[pageNum.length-1],`last`)">尾页</li>
		</ul>
	</div>
</template>

<script>
	export default {
		props:{
			total:{
				type:[String,Number],
				default:0
			},
			pageSize:{
				type:[String,Number],
				default:10
			},
			currPage:{
				type:[String,Number],
				default:1
			}
		},
		data(){
			return {
				pageNum:[],
				curr:1,
				pageNumber:0
			}
		},
		created() {
			this.curr = this.currPage
			this.init()
		},
		mounted() {
			
		},
		methods:{
			init(){
				let num = Math.round(+this.total / +this.pageSize);
				this.pageNumber = num;
				let arr = [];
				if(num <= 0){
					arr.push(1)
				}else if(num <= 11){
					for (let i=0; i < num; i++) {
						arr.push(i+1);
					}
				}else{
					this.formatPageList();
					return
				}
				this.pageNum = arr
			},
			formatPageList(){
				let _this = this;
				let curr = _this.curr;
				let num = _this.pageNumber;
				let arr = [];
				if(curr <= 6){
					arr = [`…`,num-1,num];
					for (let i=0; i < 8; ++i) {
						arr.unshift(8-i);
					}
				}else if(num - curr <= 5){
					arr = [1,2,`…`]
					for (let i=0; i < 8; ++i) {
						arr.push(num - (7-i));
					}
				}else{
					arr = [1,2,`…`,curr-2,curr-1,curr,curr+1,curr+2,`…`,num-1,num]
				}
				
				this.pageNum = arr
			},
			changePage(curr,from){
				if(this.curr == curr){
					return
				}
				this.curr = curr;
				if(this.pageNumber > 11){
					this.formatPageList();
				}
				this.$emit('changePage',this.curr);
			}
		},
		computed:{
			
		},
		watch:{
			currPage(n){
				this.curr = n
				this.init()
			}
		}
	}
</script>

<style scoped="scoped">
	@import url("./l-pages.css");
</style>



// WEBPACK FOOTER //
// src/components/l-pages/l-pages.vue